<h1>Articles and Volumes</h1>
<div class="toptext">
	<p>
		A complete list of all available volumes of <i>De Cifris Koine</i> and their articles. <br> Issues of Koine are
		completely free (<a routerLink="/koine/open-access-statement">Diamond Open Access</a>), and we
		also provide their covers so anyone can create their own copy. 
	</p>
</div>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 8: FCiR25 ACTA</b> <span class="meta">(Nov. 2025)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol8></app-vol8>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 7: CIFRIS25 ACTA</b> <span class="meta">(Sept. 2025)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol7></app-vol7>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 6: BITCOIN E BLOCKCHAIN</b> <span class="meta">(May 2025)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol6></app-vol6>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 5: CIFRIS24 ACTA</b> <span class="meta">(Feb. 2025)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol5></app-vol5>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 4: DE CIFRIS PROTOCOLS</b> <span class="meta">(Oct. 2024)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol4></app-vol4>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 3: ERUDITORUM ACTA 2024</b> <span class="meta">(Sep. 2024)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol3></app-vol3>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 2: DE CIFRIS SEMINARS</b> <span class="meta">(May 2024)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol2></app-vol2>
	</div>
</details>

<details class="collapsible">
	<summary class="collapsible-btn">
		<b>Vol. 1: CIFRIS23 ACTA</b> <span class="meta">(Apr. 2024)</span>
		<span class="arrow">&#9660;</span>
	</summary>
	<div class="collapsible-content">
		<app-vol1></app-vol1>
	</div>
</details>
<hr>